module.exports = "/images/vendor/flag-icon-css/flags/1x1/cx.svg?172a41ec42fd864193881fc48b6bf4d7";